import * as React from 'react';
import * as ReactDom from 'react-dom';

export interface PortalProps {
    /**
     *  Test id for unit and e2e
     */
    testId?: string;
}

const PortalRoot = 'referee-portal' as any;

export const Portal = React.forwardRef<typeof PortalRoot, React.PropsWithChildren<PortalProps>>((props, ref) => {
    const { children, testId, ...passThroughProps } = props;

    const documentRef = React.useRef<HTMLSpanElement>(null);
    const [targetNode, setTargetNode] = React.useState(null);

    React.useLayoutEffect(() => {
        if (!documentRef.current) {
            return;
        }

        let documentBody = document.body;
        try {
            documentBody = documentRef.current.ownerDocument.body;
        } catch (err) {
            // ignore
        }

        setTargetNode(documentBody);
    }, [documentRef]);

    return targetNode != null ? (
        ReactDom.createPortal(
            <PortalRoot ref={ref} {...passThroughProps} data-testid={testId}>
                {children}
            </PortalRoot>,
            targetNode,
        )
    ) : (
        <span ref={documentRef} />
    );
});

Portal.displayName = 'Portal';
